import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import Pusher from 'pusher-js'
import Headroom from 'headroom.js'

import RefreshApp from '../components/RefreshApp'
import Nav from './Nav'
import Footer from '../components/Footer'
import AcceptPolicyModal from '../components/modal/AcceptPolicyModal'
import ModalContainer from '../containers/ModalContainer'

import { rollbar } from '../rollbar'
import { setUserNeedsAppUpdate } from '../actions/appupdate'
import { isLocalHost, getBaseUrl } from '../utils'
import { getPusherApiKey, getQwPusherApiKey } from '../utils/pusher'
import { isAuthenticatedRoute, isFullWidthRoute } from '../utils/routes'

class App extends Component {
  componentWillMount() {
    if (
      typeof window !== 'undefined' &&
      window.location &&
      window.location.protocol === 'http:' &&
      !isLocalHost()
    ) {
      window.location.href = window.location.href.replace(/^http(?!s)/, 'https')
    }
  }

  componentDidMount() {
    if (this.props.children === null) {
      this.props.dispatch(push('/login'))
    }

    var headroom = new Headroom(document.querySelector('body'))
    headroom.init()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user && !this.props.user) {
      rollbar.configure({
        payload: {
          person: {
            id: nextProps.user.id,
            username: nextProps.user.userName,
            email: nextProps.user.email
          }
        }
      })

      window.oeQwPusherInstance = new Pusher(getQwPusherApiKey(), {
        cluster: 'mt1'
      })

      if (!this.props.token && nextProps.token) {
        window.oeQMQuestPusherInstance = new Pusher(getPusherApiKey(), {
          authEndpoint: `${getBaseUrl()}/quest_maker/pusher/auth`,
          auth: {
            headers: {
              Authorization: `Token token=${nextProps.token}`
            }
          }
        })

        const channel = window.oeQMQuestPusherInstance.subscribe('questmaker')
        const action = setUserNeedsAppUpdate
        channel.bind(
          'update',
          function () {
            this.props.dispatch(action())
          },
          this
        )
      }
    }

    if (
      nextProps.userNeedsToResetPassword &&
      nextProps.location.pathname !== '/changepassword' &&
      sessionStorage.getItem('password')
    ) {
      this.props.dispatch(push('/changepassword'))
    }
  }

  render() {
    document.querySelector('body').classList.remove('login-route')

    const { children, showAcceptPoliciesModal, appUpdateAvailable } = this.props

    let userInAuthenticatedRoute, isPoliciesRoute, fullWidthContainer
    if (children && children.props.location) {
      userInAuthenticatedRoute = isAuthenticatedRoute(
        children.props.location.pathname
      )
      isPoliciesRoute =
        children.props.location.pathname.indexOf('/policies') > -1
      fullWidthContainer = isFullWidthRoute(
        children.props.location.pathname
      )
    }

    return (
      <div id="rootContainer">
        <ModalContainer />
        {this.displayNavAndFooter() && !isPoliciesRoute && <Nav />}

        {appUpdateAvailable && <RefreshApp />}

        {this.props.isChangingOrganization ? (
          <div style={{ height: '100vh' }}>
            <div className="loading" />
          </div>
        ) : (
          <div
            id={`${userInAuthenticatedRoute ? 'content' : ''}`}
            className={`container ${!userInAuthenticatedRoute ? 'unauth' : ''} ${fullWidthContainer ? 'full-width' : ''}`}
          >
            {children}
          </div>
        )}

        {this.displayNavAndFooter() && <Footer />}

        {showAcceptPoliciesModal && <AcceptPolicyModal />}
      </div>
    )
  }

  displayNavAndFooter() {
    const { children, showAcceptPoliciesModal } = this.props

    let userInAuthenticatedRoute
    if (children && children.props.location) {
      userInAuthenticatedRoute = isAuthenticatedRoute(
        children.props.location.pathname
      )
    }

    return !showAcceptPoliciesModal && userInAuthenticatedRoute
  }
}

App.propTypes = {
  actions: PropTypes.object,
  children: PropTypes.element.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  showAcceptPoliciesModal: PropTypes.bool,
  appUpdateAvailable: PropTypes.bool,
  user: PropTypes.object,
  userNeedsToResetPassword: PropTypes.bool,
  token: PropTypes.string,
  isChangingOrganization: PropTypes.bool.isRequired
}

export const mapStateToProps = state => ({
  appUpdateAvailable: state.appupdate.appUpdateAvailable,
  showAcceptPoliciesModal: state.policies.showAcceptPoliciesModal,
  user: state.user.user,
  userNeedsToResetPassword: state.user.userNeedsToResetPassword,
  token: state.user.token,
  isChangingOrganization: state.organization.isChangingCurrentOrganization
})

export default connect(mapStateToProps)(App)
export { App as AppDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/containers/App.js